import React, { useState, useRef, useEffect } from "react";

import "./searchBar.scss";

const SearchBar = (props) => {
  let { classes, onMagGlassClick, inputValue, ...inputProps } = props;

  const [value, setValue] = useState(inputValue ?? "");

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <div className={`search-bar ${[classes && classes.join(" ")]}`}>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        type={"text"}
        ref={inputRef}
        data-cy={"search-bar"}
        {...inputProps}
      />
      <span
        className={"glyphicon glyphicon-search"}
        onClick={onMagGlassClick}
      />
    </div>
  );
};

export default SearchBar;
